// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Po-hb","toggleWrap":"styles_toggleWrap__3fY_8","content":"styles_content__3Gqzc","selectAreaCode":"styles_selectAreaCode__2kcXm"};